import { createAction } from 'redux-actions';
import { MERCHANT_NO_MID } from '../constants';

export const noMid = createAction(MERCHANT_NO_MID);
